

export const RequestContentTypes = {
    JSON: "application/json",
    MULTIPART_FORMDATA: "multipart/form-data"
};